import React from 'react';

/**
 * Footer de Producción.
 * Se han eliminado las funciones de depuración (Recarga Forzada/Limpiar Datos)
 * para ofrecer una interfaz limpia y profesional.
 */
const Footer = () => {
  const appVersion = 'v2.1.0'; 

  return (
    <footer className="mt-auto py-6 px-4 border-t border-gray-100 bg-white">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        <div className="text-center">
          <p className="text-[10px] text-gray-400 uppercase tracking-widest font-bold">
            ITURRI mini GIV • {appVersion}
          </p>
          <p className="text-[9px] text-gray-300 mt-1">
            Desarrollado para entornos de baja conectividad
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;